
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Faimilyresortnearamravati() {



  const cardData =
  {
    keyword: ' Family Resorts Near Amravati',
    heading:  'Woodland Escape: Family Resorts Near Amravati',
    headingDescription: 'Woodland Escape Resort, one of the best family resorts near Amravati, offers a perfect blend of comfort, fun, and natural beauty for a memorable family getaway. Surrounded by lush greenery, serene forest landscapes, and open lawns, the resort provides a safe and relaxing environment for family vacations, weekend retreats, or special celebrations. Guests can enjoy a variety of activities suitable for all ages, including nature walks, outdoor games, swimming, cycling, and adventure sports, while children can explore and play freely in spacious areas. With cozy cottages, delicious meals, and attentive hospitality, Woodland Escape Resort near Amravati ensures every family member experiences joy, relaxation, and togetherness amidst the refreshing beauty of nature.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Family Resorts Near Amravati",
"description": "Explore the best family resorts near Amravati that offer a perfect blend of comfort, nature, and activities. These resorts feature spacious accommodations, kids’ play areas, family-friendly dining, and recreational facilities to make your stay enjoyable for all ages."
},
{
"name": "Amravati Family Stay Resort",
"description": "Enjoy a relaxing family stay at Amravati resorts designed to cater to families with children. Comfortable rooms, engaging outdoor activities, swimming pools, and nature walks make it an ideal getaway for quality family time."
},
{
"name": "Affordable Family Resorts Amravati",
"description": "Discover budget-friendly family resorts near Amravati offering excellent facilities, safe environments for kids, fun activities, and cozy accommodations without stretching your wallet."
},
{
"name": "Amravati Weekend Family Resort",
"description": "Plan a weekend family retreat in Amravati at resorts that offer a mix of leisure, adventure, and nature. Enjoy barbecues, bonfires, sports activities, and scenic surroundings for a memorable weekend."
},
{
"name": "Amravati Kids Friendly Resort",
"description": "Choose from top kids-friendly resorts in Amravati featuring playgrounds, swimming pools, indoor games, and engaging programs to keep children entertained while parents relax in comfort."
},
{
"name": "Amravati Family Outing Resort",
"description": "Perfect for a day or weekend family outing, these resorts provide outdoor activities like trekking, cycling, nature walks, and picnic areas surrounded by lush greenery."
},
{
"name": "Amravati Nature Resort for Families",
"description": "Immerse your family in nature at Amravati’s scenic resorts. Enjoy eco-friendly stays, garden walks, bird watching, and natural landscapes designed for relaxation and bonding moments."
},
{
"name": "Amravati Riverside Family Resort",
"description": "Stay at riverside resorts in Amravati that combine waterfront views with family activities. Enjoy fishing, boating, nature trails, and peaceful surroundings for a rejuvenating family experience."
},
{
"name": "Amravati Hill Resort for Family",
"description": "Hill resorts near Amravati offer panoramic views, trekking, adventure sports, and cozy accommodations for families looking to escape city life and enjoy cooler climates."
},
{
"name": "Amravati Family Picnic Resort",
"description": "Organize a family picnic at resorts in Amravati with picnic spots, open lawns, play areas, and facilities for group activities, making it perfect for family bonding and celebrations."
},
{
"name": "Amravati Outdoor Family Resort",
"description": "Enjoy the outdoors at family resorts in Amravati featuring sports courts, adventure activities, cycling paths, and green spaces to keep all family members active and entertained."
},
{
"name": "Amravati Group Family Resort",
"description": "Ideal for large family gatherings or reunions, these resorts provide multiple accommodations, dining halls, group activities, and spacious outdoor areas to ensure a comfortable and fun experience."
},
{
"name": "Amravati Family Resort Booking",
"description": "Easily book your family resort in Amravati in advance to ensure a hassle-free stay. Enjoy curated family-friendly itineraries, meal plans, and recreational activities tailored to all age groups."
},
{
"name": "Amravati One Day Family Resort",
"description": "Perfect for a one-day family escape, these resorts offer day packages with activities like swimming, nature walks, adventure games, and delicious meals, all designed for a fun family outing."
},
{
"name": "Amravati Luxury Family Resort",
"description": "Indulge in luxury family resorts in Amravati featuring premium accommodations, spa services, gourmet dining, personalized activities, and exclusive experiences to make your family trip unforgettable."
}
],
"tableData": [
["- Family Resorts Near Amravati", "- Amravati Family Stay Resort"],
["- Affordable Family Resorts Amravati", "- Amravati Weekend Family Resort"],
["- Amravati Kids Friendly Resort", "- Amravati Family Outing Resort"],
["- Amravati Nature Resort for Families", "- Amravati Riverside Family Resort"],
["- Amravati Hill Resort for Family", "- Amravati Family Picnic Resort"],
["- Amravati Outdoor Family Resort", "- Amravati Group Family Resort"],
["- Amravati Family Resort Booking", "- Amravati One Day Family Resort"],
["- Amravati Luxury Family Resort", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Top Family Resort Near Amravati",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect family getaway near Amravati, offering a safe, serene, and forest-filled environment. Families can relax, bond, and enjoy quality time together amidst nature."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Accommodation",
    "WhyChoosedescription": "The resort provides well-appointed rooms, cottages, and day-use areas designed for family comfort. Enjoy cozy interiors, forest views, and spaces suitable for both adults and children."
  },
  {
    "WhyChooseheading": "Fun Activities for All Ages",
    "WhyChoosedescription": "From nature walks and pond-side relaxation to light adventure activities like zip-lines and rope courses, Woodland Escape Resort offers options for everyone in the family, ensuring a memorable experience for all."
  },
  {
    "WhyChooseheading": "Safe and Child-Friendly Environment",
    "WhyChoosedescription": "The resort is designed with families in mind, featuring secure play areas, supervised zones, and easy-to-navigate forest paths, allowing parents to relax while kids have fun safely."
  },
  {
    "WhyChooseheading": "Delicious Food for the Whole Family",
    "WhyChoosedescription": "Enjoy freshly prepared meals and snacks that cater to both adults and children. The resort offers family-friendly dining options made from locally sourced ingredients to keep everyone energized and satisfied."
  },
  {
    "WhyChooseheading": "Perfect for Group Outings",
    "WhyChoosedescription": "Whether it’s a family reunion, a weekend escape, or a small gathering, Woodland Escape Resort provides ample space and activities to ensure a joyful and memorable experience for families and friends alike."
  },
  {
    "WhyChooseheading": "Convenient Access from Amravati",
    "WhyChoosedescription": "Located a short drive from Amravati, Woodland Escape Resort is easy to reach for a weekend getaway or short family trip. Spend more time enjoying nature and family bonding, and less time on travel."
  }
]














  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a family resort near Amravati?",
    answer: "Woodland Escape Resort provides a safe, scenic, and activity-filled environment perfect for family getaways near Amravati. Families can enjoy nature, outdoor games, and relaxing spaces together."
  },
  {
    question: "How far is Woodland Escape Resort from Amravati city?",
    answer: "The resort is approximately 35–40 km from Amravati, which takes around 1 to 1.5 hours by car. It’s convenient for both day trips and weekend family stays."
  },
  {
    question: "What family-friendly activities are available at the resort?",
    answer: "The resort offers a variety of activities including nature walks, cycling, open-lawn games, boating (if available), and kid-friendly play areas. Adults can relax while children are engaged safely."
  },
  {
    question: "Are accommodations suitable for families?",
    answer: "Yes! Woodland Escape Resort offers comfortable cottages and rooms that can accommodate families of different sizes. The lodging provides modern amenities while keeping guests close to nature."
  },
  {
    question: "Does the resort provide food for families?",
    answer: "Yes! The resort serves freshly prepared meals including vegetarian and non-vegetarian options. Picnic-style lunches and snacks are also available, making family stays convenient and enjoyable."
  },
  {
    question: "How can we book a family stay at Woodland Escape Resort near Amravati?",
    answer: "You can book by calling or WhatsApp messaging our reservations team or visiting our website. Advance booking is recommended, especially on weekends and holidays, to ensure availability."
  }
];

const testimonials = [
  {
    name: "Mr. Sameer & Family, Amravati",
    text: "We had an amazing family stay at Woodland Escape Resort! The kids loved the play areas, the adults enjoyed the peaceful surroundings, and the food was delicious. Truly the best family resort near Amravati."
  },
  {
    name: "Miss. Priya & Family, Amravati",
    text: "Woodland Escape Resort made our weekend getaway memorable! The accommodations were comfortable, the activities fun, and the environment serene. Perfect for a family escape near Amravati."
  }
];













      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Resorts Near Amravati",
  "image": "https://woodlandescape.com/assets/images/family-resorts-near-amravati.jpg",
  "description": "Experience a perfect family getaway at Woodlandescape Resort — one of the top family resorts near Amravati. Enjoy kids-friendly activities, outdoor fun, scenic nature, and comfortable stays for a memorable weekend with your loved ones.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "814"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2899",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/family-resorts-near-amravati"
  }
};

  return (
    <div>

<Helmet>
  <title>Family Resorts Near Amravati | Kids Friendly & Scenic Stay | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a fun-filled family stay at Woodlandescape Resort — one of the best family resorts near Amravati. Enjoy kids-friendly activities, outdoor fun, scenic nature, and a comfortable weekend getaway." 
  />
  <meta 
    name="keywords" 
    content="Family Resorts Near Amravati, Amravati Family Stay Resort, Affordable Family Resorts Amravati, Amravati Weekend Family Resort, Amravati Kids Friendly Resort, Amravati Family Outing Resort, Amravati Nature Resort for Families, Amravati Riverside Family Resort, Amravati Hill Resort for Family, Amravati Family Picnic Resort, Amravati Outdoor Family Resort, Amravati Group Family Resort, Amravati Family Resort Booking, Amravati One Day Family Resort, Amravati Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/14.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Faimilyresortnearamravati;